import React, { useState, useEffect, useContext } from "react";
import { useTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { getFinca, getListFincas } from "../../../services";
import CircularProgress from "@mui/material/CircularProgress";
import ComunidadOriginal from "./diseños/original/Comunidad";
import { UsuarioContext } from "../../../providers/userContext";
import ComunidadesLegalia from "./diseños/legalia/Comunidad";
import useListNavigation from "../../../hooks/useListNavigation";

// Trae TODOS los nif de comunidades en el orden del listado (mismos filtros/orden).
const fetchAllComunidadNifs = (ctx) =>
  getListFincas({
    filtros: ctx.filtros || {},
    params: { page: 1, limit: 9999, order: ctx.order, orderBy: ctx.orderBy },
  }).then((res) => (res?.data || []).map((r) => r.nif).filter(Boolean));

const Comunidad = (props) => {
  const { t } = useTranslation(["properties", "suppliers", "common"]);
  const [finca, setFinca] = useState({});
  const [proveedores, setProveedores] = useState([]);
  const [value, setValue] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const user = useContext(UsuarioContext);
  const { prev, next } = useListNavigation('comunidades', props.params.nif, fetchAllComunidadNifs);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.params.nif]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const res = await getFinca(props.params.nif);
      setFinca(res);
      // Seleccionar por defecto la primera pestaña disponible (CAE, LOPD o CAI)
      const gruposDisponibles = [1, 2, 3].filter((g) => res?.gruposServicios?.includes(g));
      if (gruposDisponibles.length > 0) {
        setValue(gruposDisponibles[0]);
      }
      const ultimaVenta = res.sales
        .filter(s =>
          s.estado_id !== 4 && s.estado_id !== 5 &&
          [1, 3, 6, 7].includes(s.servp_id)
        )
        .reduce((max, current) => {
          return (current.id > max.id) ? current : max;
        }, { id: -1 });
      if(ultimaVenta){ // si el último sevicio no está de baja se cargan los proveedores
        setProveedores(res.suppliers);
      }
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  if (isLoading) {
    return (
      <CircularProgress
        style={{
          color: "#92004D",
          position: "absolute",
          top: "50%",
          left: "50%",
        }}
      />
    );
  }

  return (
    user.tieneLegalia ? 
      <ComunidadesLegalia
        t={t}
        finca={finca}
        proveedores={proveedores}
        value={value}
        handleChange={handleChange}
        nif={props.params.nif}
        prevNif={prev}
        nextNif={next}
      />
    :
      <ComunidadOriginal
        t={t}
        finca={finca}
        proveedores={proveedores}
        value={value}
        handleChange={handleChange}
        nif={props.params.nif}
      />
  );
};

export default withRouter(Comunidad);
